// extracted by mini-css-extract-plugin
export var header = "_dr-0";